import React, { createContext, useState, useContext, useEffect } from 'react';
import { authApi } from '../utils/authApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('jwtToken'));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      if (token) {
        try {
          const userData = await authApi.getCurrentUser(token);
          console.log('🔐 User Data Retrieved:', userData);
          console.log('👤 User ID:', userData?.id);
          console.log('📧 Username:', userData?.username);
          console.log('🎭 User Role:', userData?.role);
          console.log('🔑 Role Name:', userData?.role?.name);
          console.log('🏷️ Role Type:', userData?.role?.type);
          setUser(userData);
        } catch (err) {
          console.error('❌ Auth Check Failed:', err);
          localStorage.removeItem('jwtToken');
          setToken(null);
          setUser(null);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, [token]);

  const signup = async (email, password, firstName, lastName) => {
    try {
      setError(null);
      const response = await authApi.register(email, password, firstName, lastName);
      setToken(response.jwt);
      setUser(response.user);
      localStorage.setItem('jwtToken', response.jwt);
      return response;
    } catch (err) {
      const errorMsg = err.message || 'Aanmelden mislukt';
      setError(errorMsg);
      throw err;
    }
  };

  const login = async (email, password) => {
    try {
      setError(null);
      const response = await authApi.login(email, password);
      console.log('✅ Login Successful!');
      console.log('🔑 JWT Token:', response.jwt?.substring(0, 20) + '...');
      console.log('👤 User Data from Login:', response.user);
      console.log('🎭 User Role:', response.user?.role);
      console.log('🔑 Role Name:', response.user?.role?.name);
      setToken(response.jwt);
      setUser(response.user);
      localStorage.setItem('jwtToken', response.jwt);
      return response;
    } catch (err) {
      console.error('❌ Login Failed:', err);
      const errorMsg = err.message || 'Login failed';
      setError(errorMsg);
      throw err;
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('jwtToken');
  };

  const isAdmin = user?.role?.name === 'admin' || user?.role?.type === 'admin';
  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        error,
        signup,
        login,
        logout,
        isAdmin,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
